import React from 'react';
import { Container } from 'react-bootstrap';

import handShakeIcon from 'images/partners/hand-shake.svg';

import { useCorporateSubscriberCirclePartners, useFeaturedPartners } from '../../hooks/usePartners';
import useScrollToAnchor from '../../hooks/useScrollToAnchor';
import { PARTNER_OG_IMAGE_PATH } from '../../utils/constants';
import { Spinner } from '../BaseUI';
import MetaTags from '../shared/MetaTags';
import CorporateSubscriberCircleContainer from './CorporateSubscriberCircleContainer';
import FeaturedPartnerContainer from './FeaturedPartnerContainer';
import PartnershipOpportunitiesSection from './PartnershipOpportunitiesSection';
import styles from './styles.module.scss';

const Partners = () => {
  const { featuredPartners, isLoadingFeaturedPartners } = useFeaturedPartners();
  const { cscPartners, isLoadingCscPartners } = useCorporateSubscriberCirclePartners();
  useScrollToAnchor(isLoadingFeaturedPartners || isLoadingCscPartners);
  const description =
    'Our readers are an elite audience of Founders, ' +
    'Partners, CEOs and senior executives who are highly engaged with our content. ' +
    'They come to The Information for their news and to stay ahead. ' +
    'They look to our brand partners to build relationships. ' +
    'The Information offers reach to tech leaders and financial power brokers. ' +
    'These are the people looking to innovative new partners and who can write the checks.';

  return (
    <>
      <MetaTags
        title="The Information Partners"
        description={description}
        ogSiteName="The Information"
        ogImagePath={PARTNER_OG_IMAGE_PATH}
      />
      {isLoadingFeaturedPartners || isLoadingCscPartners ? (
        <Spinner />
      ) : (
        <>
          <Container>
            <img src={handShakeIcon} className={styles.handShakeIcon} />
            {featuredPartners.length > 0 && (
              <FeaturedPartnerContainer featuredPartners={featuredPartners} />
            )}
            {cscPartners.length > 0 && (
              <CorporateSubscriberCircleContainer cscPartners={cscPartners} />
            )}
          </Container>
          <PartnershipOpportunitiesSection />
        </>
      )}
    </>
  );
};

export default Partners;
